<template>
  <div class="" :class="{ 'no-select-hover': isAgencyDashboard, 'clickable' : !isAgencyDashboard}" @click="handleClickShop">
    <div class=" page-item-info d-flex align-items-center p-0">
      <div class="pos-absolute pos-a-tl" v-if="isNew">
        <svg width="48" height="54" viewBox="0 0 48 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 54V6C1 3.23858 3.23858 1 6 1H48L1 54Z" fill="url(#paint0_linear)" />
          <path d="M17.3384 26.2095L16.4875 27.1576L7.28239 25.7811L13.065 30.971L12.214 31.9191L4.94152 25.392L5.79247 24.4439L14.9871 25.811L9.21497 20.6305L10.0659 19.6824L17.3384 26.2095ZM20.391 16.6251C20.5715 16.7872 20.7532 16.969 20.9359 17.1707L16.8402 21.7342C17.434 22.2044 18.0465 22.4093 18.6777 22.3488C19.3082 22.275 19.8479 21.9881 20.2967 21.488C20.6645 21.0782 20.8762 20.6537 20.9318 20.2145C20.9867 19.7621 20.9043 19.3369 20.6845 18.939L21.6009 17.918C22.0125 18.5633 22.1862 19.271 22.1221 20.0411C22.051 20.805 21.7099 21.5273 21.099 22.2081C20.6127 22.7498 20.0548 23.127 19.4252 23.3394C18.8018 23.5449 18.1587 23.5698 17.496 23.4139C16.8263 23.2518 16.1963 22.9058 15.6058 22.3759C15.0154 21.846 14.6039 21.2635 14.3713 20.6283C14.1387 19.9932 14.0945 19.3578 14.2386 18.7221C14.382 18.0733 14.7031 17.471 15.2018 16.9153C15.6881 16.3735 16.2363 16.0002 16.8465 15.7954C17.4567 15.5906 18.07 15.5641 18.6862 15.7159C19.3018 15.8545 19.87 16.1575 20.391 16.6251ZM19.314 17.4268C18.9528 17.1026 18.572 16.9051 18.1716 16.8342C17.7643 16.7571 17.3699 16.7982 16.9886 16.9576C16.6066 17.1038 16.2659 17.3436 15.9667 17.677C15.5365 18.1563 15.3215 18.7033 15.3217 19.3179C15.3281 19.9256 15.5803 20.4969 16.0785 21.0318L19.314 17.4268ZM25.7045 5.40185L29.8151 12.3079L28.9361 13.2873L23.1694 10.5949L26.4674 16.0379L25.5884 17.0173L18.2703 13.685L19.14 12.716L25.111 15.7047L21.59 9.98624L22.4596 9.01726L28.5065 11.9424L24.8629 6.33957L25.7045 5.40185Z" fill="white" />
          <defs>
            <linearGradient id="paint0_linear" x1="1" y1="1" x2="52.1625" y2="5.38023" gradientUnits="userSpaceOnUse">
              <stop stop-color="#004CE0" />
              <stop offset="1" stop-color="#1DA6F3" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="page-item-info-image mr-2">
        <img v-if="noError && shop.home_thumbnail != null" :src="shop.home_thumbnail" @error="imageLoadOnError"/>
        <img v-else :src="publicPath + require('@/core/assets/ThumbnailPlaceholder.jpg')" />
      </div>
      <div class="page-item-info-body align-items-center" :class="{'page-item-info-body-agency' : isAgencyDashboard}">
        <div class="page-item-info-body-title">
        <p class="typo-heading16 typo-medium text-light-high">{{ shop.profile.name }}</p>
        </div>
        <div class="d-flex mt-half text-grey2">
          <p class="typo-paragraph12 typo-regular text-light-low">{{ shop.profile.domain }}</p>
        </div>
      </div>
    </div>

    <div class=" d-flex flex-column text-center" :class="{ onModal: !isAgencyDashboard}">
      <div class="page-item-info-time mt-half" :class="classObject"><span class="typo-button14 typo-medium text-light-low">{{ PLAN_NAMES[shop.plan] }}</span></div>
      <div class="page-item-info-time mt-half text-grey2">
        <p class="typo-paragraph12 typo-regular text-light-low">{{ $t("generals.added") }} {{ timeago }}</p>
      </div>
    </div>

    <div class="d-flex ml-auto mr-2" v-if="isAgencyDashboard">
      <div class="d-flex  text-center "  >
        <!-- <div class="col-12 col-mlg-4 col-xl-4 p-0 align-items-center "> -->
        <!-- <p class="typo-small typo_shade6 text-grey2 loginShopBtn" @click="showLoginShop">{{$t("agency.accessStore")}}</p> -->
        <span class="typo-small loginShopBtn mr-1" @click="showLoginShop">{{ $t("agency.accessStore") }}</span>
        <!-- </div> -->
        <div class="text-light-low">
          <div class="page-item-tools-mini">
            <div class="page-item-tools-mini-dropdown">
              <!-- <ShopItemDropdown :shop="shop" /> -->
              <div class="btn-block gp_dropdown-button text-light-low">
                <button class="btn btn-clean py-0 py-mlg-1 icon-delete text-light-low" @click="openModal">
                  <i class="icon text-light-low"></i>
                </button>
              </div>
              <!-- <button class="btn btn-clean">
                <i class="icon icon-delete typo-body1 text-grey2"></i>
              </button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal :hideExit="true" @cancel="closeModalShopLogin" v-if="modalAgencyShopLogin">
      <template #header>
        <p class="typo-title1">{{ $t("agency.modalLogin.title") }}</p>
      </template>
      <template #default>
        <template>
          <p class="typo-body2 text-grey2">
            {{ $t("agency.modalLogin.youWill") }}
            <span class="text-primary">{{ shopConfirm.profile.name }}</span>
          </p>
        </template>
      </template>
      <template #footer>
        <div class="btn-group">
          <button class="btn btn-outline ml-auto" @click="closeModalShopLogin">{{ $t("generals.cancel") }}</button>

          <ProcessButton class="btn btn-primary ml-2" :status.sync="shopLogStatus" @click="loginShop(shopConfirm)" default="btn-primary">
            {{ $t("generals.apply") }}
            <!-- <template #loading>Apply</template>
            <template #success>Apply</template>
            <template #error>Apply</template>
            <template #default>Apply</template>-->
          </ProcessButton>
        </div>
      </template>
    </Modal>
    <Modal :hideExit="true" @cancel="closeModal" v-if="modalActive">
      <template #header>
        <p class="typo-title1">{{ $t("agency.modalDelete.title") }}</p>
      </template>
      <template #default>
        <template>
          <p class="typo-body2 text-grey2">
            {{ $t("agency.modalDelete.areYouSure") }}&nbsp; <span class="text-black1">“{{ shop.profile.name }}”</span> ?
          </p>
        </template>
      </template>
      <template #footer>
        <div class="btn-group">
          <button class="btn btn-outline ml-auto" @click="closeModal">{{ $t("generals.cancel") }}</button>
          <ProcessButton class=" ml-2" :status.sync="shopUnlinkStatus" @click="deleteShop" default="btn-danger">
            <template #loading>{{ $t("generals.delete") }}</template>
            <template #success>{{ $t("generals.delete") }}</template>
            <template #error>{{ $t("generals.delete") }}</template>
            <template #default>{{ $t("generals.delete") }}</template>
          </ProcessButton>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { TimeMaker } from "@/plugins";
import { mapActions, mapState, mapGetters } from "vuex";
import { ProcessButton } from "@/core/shared";
import {PLAN_NO, PLAN_NAMES} from "@/contants/plan";
export default {
  name: "ShopItem",
  components: {
    ProcessButton
  },
  props: {
    shop: Object,
    isAgencyDashboard: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modalAgencyShopLogin: false,
      shopConfirm: Object,
      modalActive: false,
      noError: true,
      PLAN_NAMES
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    ...mapState("agency", {
      shopLogStatus: state => state.shopLogStatus,
      shopUnlinkStatus: state => state.shopUnlinkStatus
    }),
    timeago() {
      return new TimeMaker(this.shop.agency_created).ago(this.language);
    },
    getPlan() {
      const { STARTER, PROFESSIONAL, ADVANCED, BUILD, OPTIMIZE, ENTERPRISE} = PLAN_NO;
      return {
        [STARTER]: "Starter",
        [PROFESSIONAL]: "Build",
        [BUILD]: "Build",
        [ADVANCED]: "Optimize",
        [OPTIMIZE]: "Optimize",
        [ENTERPRISE]: "Enterprise",

      }
    },
    classObject: function() {
      return {
        advanced: this.shop.plan === "advanced",
        professional: this.shop.plan === "professional",
        starter: this.shop.plan === "starter",
        trial: this.shop.plan === "trial"
      };
    },
    isNew() {
      let today = new Date();
      let d1 = today.getDate();
      let m1 = today.getMonth();
      let y1 = today.getFullYear();
      let date = Date.parse(this.shop.agency_created);
      date = new Date(date);
      let d2 = date.getDate();
      let m2 = date.getMonth();
      let y2 = date.getFullYear();
      return d1 == d2 && m1 == m2 && y1 == y2;
    }
  },
  created() {},
  methods: {
    ...mapActions("agency", {
      loginShopFromAgency: "loginShopFromAgency",
      unlinkShop: "unlinkShop"
    }),
    showLoginShop() {
      this.modalAgencyShopLogin = true;
      this.shopConfirm = this.shop;
    },
    closeModalShopLogin() {
      this.modalAgencyShopLogin = false;
    },
    async loginShop() {
      await this.loginShopFromAgency(this.shopConfirm);
      this.modalAgencyShopLogin = false;
    },

    openModal() {
      this.modalActive = true;
    },
    closeModal() {
      this.modalActive = false;
    },
    deleteShop() {
      this.unlinkShop(this.shop)
        .then(() => {
          this.modalActive = false;
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: (err.response && err.response.data && err.response.data.message) || this.$t("status.error"),
            type: "error"
          });
        });
    },
    imageLoadOnError(){
      this.noError = false
    },
    handleClickShop(){
      if ( this.isAgencyDashboard ) {
        return
      }
      this.showLoginShop()
    },
    generateNameFromUrl(shopify_domain, url, type) {
      
      // Replace useless chareacters with UNDERSCORE
      // url = url.replace("://", "_").replace(".", "_").replace(/\//g, "_");
      let myURL = new URL(url);
      url = myURL.pathname + myURL.search;
      url = this.string_to_slug(url);
      return "https://gempages-screenshots-lambda.s3.amazonaws.com/" + shopify_domain + "/" + url + type;
    },
    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();
      // remove accents, swap ñ for n, etc
      let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      let to = "aaaaeeeeiiiioooouuuunc------";
      for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }
      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes
      return str;
    }
  }
};
</script>

<style lang="scss" scoped>

.noBorderHover{
  &:hover{
    box-shadow: 0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14), 0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064), 0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455), 0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07), 0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545), 0px 12px 38px rgba(34, 34, 34, 0.0393604) !important;
  }
}

.btn-footer {
  button {
    min-width: 40px;
  }
}

.onModal{
  margin-left: auto;
  margin-right: 127px;
}
.loginShopBtn {
  cursor: pointer;
  padding: 10px 25px;
  color: $shade6;
  background: $neutral5;
  border-radius: 5px;
}

.loginShopBtn:hover {
  color: #42c184;
  background: #f2f4f6;
}

.icon-delete {
  // border-radius : 50%;
  // width: 30px;
  // height: 30px;
  padding: 14px 10px;
  width: 34px;
  height: 34px;
  display: flex !important;
  justify-content: center;
  border-radius: 50%;
  color: $textLightModeLow !important;
}

.icon-delete:hover {
  color: $cPrimary;
  @include trans-all;
  // background: $grey4;
}
// .loginShopBtn:hover{
//   color: #0060e5;
//   @include trans-all;
// }
</style>
